import '../../styles/colors.scss'
import '../../styles/filters.scss'
import './Accordion.scss'

import React, { useState } from 'react'
import { Collapse } from 'react-bootstrap'

import { left_icon } from '../../assets'
import { AccordionPropsCustom } from '../../types/Accordion'
import Image from '../image/Image'

const Accordion: React.FC<AccordionPropsCustom> = ({
  title,
  head,
  children,
  separator,
  default_expanded = false,
  icon_size = 16,
  classes,
  classes_head = "m-0 p-0 d-flex justify-content-between flex-nowrap",
  classes_title = "m-0 p-0",
  classes_icon = "",
  ...props
}: AccordionPropsCustom) => {
  /**
   * UseState
   */
  const [open, set_open] = useState(default_expanded);

  return (
    <main className={classes}>
      {/* Head */}
      <div
        className={classes_head}
        role="button"
        onClick={() => set_open(!open)}
      >
        {head || <div className={classes_title}>{title}</div>}
        <Image
          src={left_icon}
          width={icon_size}
          height={icon_size}
          className={`
            icon ${open ? "" : "rotate"}
            ${classes_icon}
          `}
        />
      </div>

      {/* Separator */}
      {separator && <hr className={separator} />}

      {/* Collapse */}
      <Collapse in={open} {...props}>
        <div className="m-0 p-0">{children}</div>
      </Collapse>
    </main>
  );
};

export default Accordion;
